import React, { useContext, useEffect, useRef, useState } from 'react';
import { Col, Dropdown, Modal, Row, Spinner } from 'react-bootstrap';
import Truck from 'assets/customizeIcons/Truck.svg';
import ProductIcon from 'assets/customizeIcons/product.svg';
import SimulatorIcon from 'assets/customizeIcons/simulator.svg';
import Input from 'components/bootstrap/forms/Input';
import DevisTable from './DevisTable';
import { useLogicDevis } from 'pages/Devis/hooks/useLogicDevis';
import { COLORS, statut } from './Mobile';
import UpdateDevisLineModal from './UpdateDevisLineModal';
import Button from 'components/bootstrap/Button';
import SignaturePopup from 'pages/Devis/components/SignaturePopup';
import moment from 'moment';
import EmailSendPopup from 'pages/comptabilite/CommunComptabilite/EmailSendPopup';
import { deleteAPI, putAPI } from 'apis/backend/apiNode';
import Forfait from 'assets/img/forfaits.png';
import MainDoeuvre from 'assets/img/main-doeuvre.png';
import Garantie from 'assets/img/garantie.png';

import { useLogicProduit } from 'pages/Stock/hooks/useLogicProduit';
import SimulatorPopUpFacile from 'pages/Devis/components/SimulateurFacile/SimulatorPopUpFacile';
import forfaitsVolet from 'constants/simulatorDataFacile/voletRoulant/forfaits';
import forfaitsStore from 'constants/simulatorDataFacile/Storebanne/forfaits';
import forfaitsRideau from 'constants/simulatorDataFacile/rideauMetallique/forfaits';
import forfaitsPorte from 'constants/simulatorDataFacile/PorteGarage/forfaits';
import forfaitsPortail from 'constants/simulatorDataFacile/Portail/forfaits';
import PorteGarageData from 'constants/simulatorDataFacile/PorteGarage';
import PortailData from 'constants/simulatorDataFacile/Portail';
import SimulatorPopUp from 'pages/Devis/components/Simulateur/SimulatorPopUp';

import MainOuvreDataVolet from 'constants/simulatorDataFacile/voletRoulant/mainOeuvre';
import MainOuvreDataRideau from 'constants/simulatorDataFacile/rideauMetallique/mainOeuvre';
import MainOuvreDataPorte from 'constants/simulatorDataFacile/PorteGarage/mainOeuvre';
import MainOuvreDataPortail from 'constants/simulatorDataFacile/Portail/mainOeuvre';
import MainOuvreDataStore from 'constants/simulatorDataFacile/Storebanne/mainOeuvre';
import voletRoulant from 'constants/simulatorDataDetails/voletRoulant';
import StoreBanneData from 'constants/simulatorDataDetails/Storebanne';
import RideauMetalliqueData from 'constants/simulatorDataDetails/rideauMetallique';
import simulatorData from 'constants/simulatorDataDetails';
import ForfaitsSM from 'constants/simulatorDataFacile/Forfaits';
import MainOuvreData from 'constants/simulatorDataFacile/MainOuvre';
import SvgArrowBack from "assets/customizeIcons/svg-icons/ArrowBackIcon";
import SaveIcon from 'assets/customizeIcons/svg-icons/SaveIcon.js';
import ConfirmationPopup from 'components/PlanningCalendar/ConfirmationPopup';
import Icon from 'components/icon/Icon';
import AuthContext from 'contexts/authContext';

function UpdateDevisModal({ isOpen, onClose, devisData, AddDevis, DeleteDevis, UpdateDevis, interventionData, taxes }) {
	const [lineDevisPopup, setLineDevisPopup] = useState(false);
	const [selectedLineDevis, setSelectedLineDevis] = useState(false);
	const [spinner, setSpinner] = useState(false);
	const [editModalSimulator, setEditModalSimulator] = useState(false);
	const [editModalSimulatorFacile, setEditModalSimulatorFacile] = useState(false);
	const [spinnerDepacement, setSpinnerDepacement] = useState(false);
	const [data, setData] = useState(devisData);
	const { updateDevis } = useLogicDevis();
	const [openEmail, setOpenEmail] = useState(false);
	const [editModalForfait, setEditModalForfait] = useState(false);
	const [addSimulatorLoading, setAddSimulatorLoading] = useState(false);
	const { createProduit } = useLogicProduit();
	const [isSaved, setIsSaved] = useState(true)
	const [currentFormValue, setCurrentFormValue] = useState({});
	const isAccepted = devisData?.statut === 'accepté';
	const [loadingDuplique, setLoadingDuplique] = useState(false)

	const simulatorDetailsMap = {
		volet: voletRoulant,
		store: StoreBanneData,
		rideaux: RideauMetalliqueData,
		porte: PorteGarageData,
		portail: PortailData,
	};
	const forfaitMap = {
		volet: forfaitsVolet,
		store: forfaitsStore,
		rideaux: forfaitsRideau,
		porte: forfaitsPorte,
		portail: forfaitsPortail,
	};
	const mainDoeuvreMap = {
		volet: MainOuvreDataVolet,
		store: MainOuvreDataStore,
		rideaux: MainOuvreDataRideau,
		porte: MainOuvreDataPorte,
		portail: MainOuvreDataPortail,
	};
	const modalTitle = {
		volet: 'VOLET ROULANT',
		store: 'STORE BANNE',
		rideaux: 'RIDEAU METALLIQUE',
		porte: 'PORTE DE GARAGE',
		portail: 'PORTAIL ELECTRIQUE',
	};
	const addDeplacement = () => {
		if (isAccepted) return; // No action if accepted
		const alreadyExists = (data?.lignes || []).some(
			(ligne) => ligne?.description === 'Déplacement',
		);

		// Do not add if it already exists
		if (alreadyExists) return;
		const newLigne = {
			type: 'service',
			produitId: null,
			nom: 'Déplacement',
			description: 'Déplacement',
			quantite: 1,
			unite: 'Piece',
			prixUnitaireHT: 50,
		};
		const newAmountUntaxed = data.totalHT + 50;
		const newAmountTVA = newAmountUntaxed * (data.tva / 100);

		setData((prev) => ({
			...prev,
			updated: true,
			totalTTC: newAmountUntaxed + newAmountTVA,
			montantTVA: newAmountTVA,
			totalHT: newAmountUntaxed,
			lignes: [...(prev?.lignes || []), newLigne],
		}));
	};
	const [openSignature, setOpenSignature] = useState(false);

	const isFirstRender = useRef(true); // 1. Create the flag

	useEffect(() => {
		// 2. Check if it's the first mount
		if (isFirstRender.current) {
			isFirstRender.current = false;
			setIsSaved(true); // Ensure initial status is "Saved"
			return;
		}

		// --- Everything below only runs on subsequent changes ---
		setIsSaved(false);

		const delayDebounceFn = setTimeout(async () => {
			if (!data?._id) return;

			try {
				const payload = { ...data };
				const { createdBy, ...restOfPayload } = payload;

				const res = await updateDevis(data?._id, { ...restOfPayload });

				if (res?.data) {
					UpdateDevis(res.data);
				}

				setTimeout(() => {
					setIsSaved(true);
				}, 300);

			} catch (error) {
				console.error("Autosave error:", error);
				setIsSaved(true);
			}
		}, 500);

		return () => clearTimeout(delayDebounceFn);
	}, [data]);

	const handleUpdateDevis = async () => {
		setSpinner(true);
		const payload = {
			...data,
		};
		const res = await updateDevis(data?._id, payload);
		setSpinner(false);
		UpdateDevis(res?.data);
		onClose();
	};

	const handleAcceptDevis = async (res) => {
		setSpinner(true);
		UpdateDevis(res);
		setSpinner(false);
		onClose();
	};
	const handleSendEmail = async () => {
		const res = await putAPI('devis', {}, `/${data?._id}/envoyer`);
		setSpinner(true);
		UpdateDevis(res?.data);
		setSpinner(false);
		onClose();
	};

	const addGarantie = () => {
		const alreadyExists = (data?.lignes || []).some(
			(ligne) => ligne?.description === 'Garantie 5 ans',
		);

		// Do not add if it already exists
		if (alreadyExists) return;
		const newLigne = {
			type: 'note',
			produitId: null,
			nom: 'Garantie', // CORRECTION: Initialiser le champ nom
			description: 'Garantie 5 ans',
			quantite: 1,
			prixUnitaireHT: 0,
		};

		setData((prev) => ({
			...prev,
			updated: true,
			lignes: [...(prev?.lignes || []), newLigne],
		}));
	};

	const handelAddFournitureLine = async () => {
		setAddSimulatorLoading(true);
		const getValue = (key) =>
			currentFormValue?.ordered?.find((i) => i?.key === key)?.originalValue;

		/* -------------------- shared values -------------------- */
		const typeProduct = getValue("typeproduct");
		const typeInstallation = getValue("typeInstallation");
		const Moteur = getValue("Moteur");
		const typeMotor = getValue("typeMotor");
		const puissance = getValue("puissance");

		const largeur = Number(getValue("largeur")) || 0;
		const hauteur = Number(getValue("hauteur")) || 0;
		const lameTaille = String(getValue("lameTaille") || "");
		const coulisse = String(getValue("coulisse") || "").toLowerCase();

		const surfaceM2 = (largeur * hauteur) / 1000000;
		const isSmallLame = ["37", "43"].includes(lameTaille);

		/* -------------------- helpers -------------------- */
		const round = (v) => Math.round(v * 100) / 100;

		const epaisseurLame = {
			37: "7 mm",
			43: "9 mm",
			55: "13 mm",
		}[lameTaille] || "";

		/* -------------------- pricing -------------------- */
		const getPrixUnitaireHT = () => {
			/* KIT MANUEL */
			if (typeProduct === "Kit Manuel") {
				return typeInstallation === "Traditionnel"
					? largeur < 2000 ? 320 : 440
					: largeur < 2000 ? 280 : 380;
			}

			if (typeProduct === "Kit Motorisation" || typeProduct === "Moteur") {
				const puissanceValue = Number(puissance); // "10", "20", ...

				const steps = Math.max((puissanceValue / 10) - 1, 0);

				if (typeMotor === "radio") {
					const base = 228.98;
					const increment = 70;

					return round(base + steps * increment);
				}

				if (typeMotor === "filaire") {
					const base = 188.98;
					const increment = 70;

					return round(base + steps * increment);
				}
			}

			/* TABLIER */
			if (typeProduct === "Tablier Volet roulant") {
				let prix =
					surfaceM2 *
					(isSmallLame ? 55 : 75) +
					(isSmallLame ? 115 : 120);

				if (coulisse === "oui") prix += 120;

				return round(prix);
			}

			/* VOLET MANUEL COMPLET */
			if (typeProduct === "Volet Roulant Complet Manuel") {
				let prix =
					surfaceM2 *
					(isSmallLame ? 55 : 75) +
					(isSmallLame ? 115 : 120) +
					198.98;

				return round(prix);
			}

			/* VOLET MOTORISÉ COMPLET */
			if (typeProduct === "Volet Roulant Complet Motorisé") {
				const baseRate = isSmallLame ? 55 : 75;
				const baseFixed = isSmallLame ? 115 : 120;

				let prix = surfaceM2 * baseRate + baseFixed;

				if (Moteur !== "Somfy") {
					const extra = {
						filaire: 209.98,
						radio: 279.98,
						solaire: 279.98,
					};
					prix += extra[typeMotor] || 0;
				} else {
					const somfy = {
						filaire: isSmallLame ? 500 : 600,
						radio: isSmallLame ? 550 : 650,
						solaire: isSmallLame ? 600 : 700,
					};

					const rate = isSmallLame ? 70 : 85;
					prix = surfaceM2 * rate + (somfy[typeMotor] || 0);
				}

				return round(prix);
			}

			return currentFormValue?.price || 0;
		};

		/* -------------------- description -------------------- */
		const getDescription = () => {
			const ressort = getValue("ressort");
			const typeMesureLargeur = getValue("typeMesureLargeur");
			const coteManivelle = getValue("cote_manivelle");
			const matiereOldLame = getValue("matiereOldLame");
			const typeMesureHauteur = getValue("typeMesureHauteur");

			const couleur = getValue("Couleur de lame");
			const coulisseState = getValue("coulisse");
			const couleurCoulisse = getValue("Couleur de coulisse");

			const agraffe = getValue("isWithAgraffe");
			const nbrAgraffe = getValue("attaches");

			const axe = getValue("axe");
			const manoeuvreManuel = getValue("manoeuvreManuel");

			const poussoir = getValue("poussoir");
			const telecommande = getValue("telecommande");
			const typeTelecommande = getValue("typeTelecommande");
			const puissance = getValue("puissance");

			/* KIT MANUEL */
			if (typeProduct === "Kit Manuel") {
				if (typeInstallation === "Traditionnel") {
					return `
						Remplacement Mécanisme Complet Volet Roulant ${typeInstallation} à Manivelle :
- Dépose de l'ensemble du mécanisme défectueux.
- Fourniture et remplacement de l'axe d'enroulement complet ${matiereOldLame == "Bois" ? "avec ressort" : ressort}.
- Fourniture et remplacement du couple conique.
- Fourniture et remplacement de la sortie de caisson hexagonale.
- Fourniture et remplacement de la manivelle complète.
- Fourniture et remplacement des attaches de tablier.
- Réglage du tablier et contrôle de l'enroulement.
- Vérification de la manœuvre et des points d'arrêt.
- Essais complets et remise en service du volet roulant.

- Largeur : ${largeur} mm ${typeMesureLargeur}
- Côté manœuvre : ${coteManivelle}
- Matière tablier existant : ${matiereOldLame}
				`.trim();
				}

				return `
					Remplacement Mécanisme Complet Volet Roulant ${typeInstallation} à Manivelle:
- Dépose de l'ensemble du mécanisme défectueux.
- Fourniture et remplacement de l'axe d'enroulement complet.
- Fourniture et remplacement du TREUIL TECHNIVIS.
- Fourniture et remplacement de la sortie de caisson hexagonale.
- Fourniture et remplacement de la manivelle complète.
- Fourniture et remplacement des attaches de tablier.
- Réglage du tablier et contrôle de l'enroulement.
- Vérification de la manœuvre et des points d'arrêt.
- Essais complets et remise en service du volet roulant.

- Largeur : ${largeur} mm ${typeMesureLargeur}
- Côté manœuvre : ${coteManivelle}
			`.trim();
			}

			/* TABLIER */
			if (typeProduct === "Tablier Volet roulant") {
				const detailsCoulisse =
					coulisseState === "oui"
						? `Avec coulisses coloris ${couleurCoulisse}`
						: "";

				const detailsAgraffe =
					agraffe === "oui" ? `, avec ${nbrAgraffe} agraffe` : "";

				return `
Fourniture d’un tablier volet roulant ${typeInstallation} en aluminium ${couleur} .
- MARQUE BUILDING, Lames aluminium DP${lameTaille}, épaisseur ${epaisseurLame} double paroi avec mousse polyuréthane injectée densité env. 75 kg/m³.
- Isolation thermique additionnelle ΔR jusqu’à 0,22 m².K/W.
- Dimensions : Largeur ${largeur} mm ${typeMesureLargeur} x Hauteur ${hauteur} mm ${typeMesureHauteur}.
- ${detailsCoulisse} ${detailsAgraffe}.
- Confort acoustique : réduction significative des bruits extérieurs (-5 dB).
- Structure aluminium thermolaquée résistante à la corrosion, aux UV et aux intempéries.
			`.trim();
			}

			/* COMPLET MANUEL */
			if (typeProduct === "Volet Roulant Complet Manuel") {
				return `
Fourniture d’un volet roulant ${typeInstallation} manuel en aluminium ${couleur}.
- MARQUE BUILDING
- Tablier en lames aluminium DP${lameTaille}, épaisseur ${epaisseurLame} double paroi avec mousse polyuréthane injectée densité env. 75 kg/m³.
- Isolation thermique additionnelle ΔR jusqu’à 0,22 m².K/W.
- Dimensions : Largeur ${largeur} mm ${typeMesureLargeur} x Hauteur ${hauteur} mm ${typeMesureHauteur}.
- Confort acoustique : réduction significative des bruits extérieurs (-5 dB).
- Structure aluminium thermolaquée résistante à la corrosion, aux UV et aux intempéries.
- Axe d’enroulement ${axe}
- Manœuvre par ${manoeuvreManuel} côté ${coteManivelle}
			`.trim();
			}

			/* COMPLET MOTORISÉ */
			if (typeProduct === "Volet Roulant Complet Motorisé") {
				return `
Fourniture d’un volet roulant ${typeInstallation} motorisé en aluminium ${couleur}.
- Tablier en lames aluminium DP${lameTaille}, épaisseur ${epaisseurLame} double paroi avec mousse polyuréthane injectée densité env. 75 kg/m³.
- Isolation thermique additionnelle ΔR jusqu’à 0,22 m².K/W.
- Dimensions : Largeur ${largeur} mm ${typeMesureLargeur} x Hauteur ${hauteur} mm ${typeMesureHauteur}.
- Confort acoustique : réduction significative des bruits extérieurs (-5 dB).
- Structure aluminium thermolaquée résistante à la corrosion, aux UV et aux intempéries.
- Motorisation ${typeMotor} ${Moteur} ${puissance ? `puissance ${puissance}` : ""} ${typeMotor === "solaire" ? "avec panneau photovoltaïque." : ""
					} ${poussoir || ""}
${typeMotor === "solaire" ? "- Batterie autonome Li-ion : jusqu’à 30 jours d’autonomie sans recharge solaire." : ""}
${telecommande === "Avec télécommande"
						? `- Commande radio ${typeTelecommande || ""} IO-Homecontrol compatible domotique connectée.`
						: ""
					}
			`.trim();
			}

			return currentFormValue?.productFinal;
		};

		/* -------------------- final -------------------- */
		const prixUnitaireHT = getPrixUnitaireHT();
		const newLine = {
			type: 'service',
			nom: 'Fourniture',
			description: getDescription(),
			prixUnitaireHT: prixUnitaireHT,
			quantite: 1,
			unite: 'Piece',
			categorie: 'materiel',
		};

		setAddSimulatorLoading(false);
		setCurrentFormValue({});
		setEditModalSimulator(false);
		const newAmountUntaxed = data?.totalHT + newLine?.prixUnitaireHT;
		const newAmountTVA = newAmountUntaxed * (data?.tva / 100);

		setData((prev) => ({
			...prev,
			updated: true,
			totalTTC: newAmountUntaxed + newAmountTVA,
			montantTVA: newAmountTVA,
			totalHT: newAmountUntaxed,
			lignes: [...(prev?.lignes || []), { ...newLine }],
		}));
	};
	const calcTotals = (lignes = [], tauxTVA = 0) => {
		const totalHT = lignes.reduce(
			(sum, l) => sum + (Number(l?.quantite) || 0) * (Number(l?.prixUnitaireHT) || 0),
			0,
		);

		const tva = totalHT * ((Number(tauxTVA) || 0) / 100);
		return { totalHT, montantTVA: tva, totalTTC: totalHT + tva };
	};

	const handelCreateForfaitLine = async () => {
		setAddSimulatorLoading(true);

		try {
			const description = currentFormValue?.productFinal;
			// const description = formatDescription(currentFormValue);
			const prixUnitaireHT = currentFormValue['price'];
			const lineToAdd = {
				type: 'service',
				produitId: null,
				nom: `Forfait`,
				description,
				quantite: 1,
				unite: 'Piece',
				prixUnitaireHT,
			};

			// ✅ Update devis draft state (lines + totals) once
			setData((prev) => {
				const newLignes = [...(prev?.lignes || []), lineToAdd];
				const tauxTVA = Number(prev?.tauxTVA) || 0;
				const totals = calcTotals(newLignes, tauxTVA);

				return {
					...prev,
					updated: true,
					lignes: newLignes,
					...totals,
				};
			});

			// ✅ reset UI
			setCurrentFormValue({});
			setEditModalForfait(false);
		} catch (err) {
			console.error('❌ Error:', err);
			showNotification('Erreur', err?.message || 'Erreur inconnue', 'danger');
		} finally {
			setAddSimulatorLoading(false);
		}
	};
	const handelCreateMainDoeuvreLine = async () => {
		setAddSimulatorLoading(true);

		try {
			const description = `Main d'oeuvre:\n${currentFormValue?.productFinal}`;
			// const description = formatDescription(currentFormValue);
			const prixUnitaireHT = currentFormValue['price'];
			const lineToAdd = {
				type: 'service',
				produitId: null,
				nom: `MainDoeuvre`,
				description,
				quantite: 1,
				unite: 'Piece',
				prixUnitaireHT,
			};

			// ✅ Update devis draft state (lines + totals) once
			setData((prev) => {
				const newLignes = [...(prev?.lignes || []), lineToAdd];
				const tauxTVA = Number(prev?.tauxTVA) || 0;
				const totals = calcTotals(newLignes, tauxTVA);

				return {
					...prev,
					updated: true,
					lignes: newLignes,
					...totals,
				};
			});

			// ✅ reset UI
			setCurrentFormValue({});
			setEditModalForfait(false);
		} catch (err) {
			console.error('❌ Error:', err);
			showNotification('Erreur', err?.message || 'Erreur inconnue', 'danger');
		} finally {
			setAddSimulatorLoading(false);
		}
	};
	const handelCreateFournitureLine = async () => {
		try {
			const description = currentFormValue?.productFinal;
			// const description = formatDescription(currentFormValue);
			const dbLine = {
				name: 'fourniture',
				description,
				type: 'stockable',
				unit: 'Piece',
				sellingPrice: 0,
			};

			const resProduit = await createProduit(dbLine);
			const produitId = resProduit?.data?._id;
			const lineToAdd = {
				type: 'produit',
				produitId: produitId,
				nom: `Fourniture ${baseTitle}`,
				description,
				quantite: 1,
				unite: 'Piece',
				prixUnitaireHT: 0,
			};

			// ✅ Update devis draft state (lines + totals) once
			setData((prev) => {
				const newLignes = [...(prev?.lignes || []), lineToAdd];
				const tauxTVA = Number(prev?.tauxTVA) || 0;
				const totals = calcTotals(newLignes, tauxTVA);

				return {
					...prev,
					updated: true,
					lignes: newLignes,
					...totals,
				};
			});

			// ✅ reset UI
			setCurrentFormValue({});
			setEditModalSimulatorFacile(false);
		} catch (err) {
			console.error('❌ Error:', err);
			showNotification('Erreur', err?.message || 'Erreur inconnue', 'danger');
		} finally {
			setAddSimulatorLoading(false);
		}
		setAddSimulatorLoading(true);
	};
	const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
	const [deleteLoading, setDeleteLoading] = useState(false);

	const handleDelete = async () => {
		setDeleteLoading('true');
		try {
			await deleteAPI('devis', `/${data?._id}`);
			DeleteDevis(data?._id)
			onClose();

		} catch (err) {
			console.log('Erreur lors de la suppression: ' + err.message);
		} finally {
			setDeleteLoading(false);
		}
	}
	const { userData } = useContext(AuthContext);
	const { createDevis } = useLogicDevis();
	const handleDupliquer = async () => {
		setLoadingDuplique(true)
		const technicienIds =
			interventionData?.cars
				?.flatMap((car) => (car?.conducteurs || []).map((c) => c?.technicien))
				?.map((t) => t?._id || t?.id)
				?.filter(Boolean) || [];
		const payload = {
			clientId: interventionData?.client?._id,
			companyId: interventionData?.cars[0]?.companyId,
			createdBy: userData?.id,
			dateValidite: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
				.toISOString()
				.split('T')[0],
			name: data?.name,
			lignes: data?.lignes,
			tva: data?.tva,
			technicienIds,
			notesClient: data?.notesClient
		};
		const resultDevis = await createDevis(payload);
		AddDevis(resultDevis?.data);
		setLoadingDuplique(false)

		onClose();
	}

	return (
		<Modal
			show={true}
			onHide={() => { }}
			size='xl'
			fullscreen
			scrollable
		>
			<Modal.Header className="bg-white border-bottom">
				<div
					style={{
						width: '100%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						gap: 10,
					}}
				>
					{/* Bouton Retour */}
					<div
						onClick={onClose}
						style={{
							color: COLORS.INFO
						}}
					>
						<SvgArrowBack size={25} color={COLORS.INFO} />
						Retour
					</div>
					{!isAccepted &&
						<div style={{ display: 'flex', alignItems: 'center', gap: 6, height: 35 }}>
							{!isSaved ? (
								<span className='text-danger' style={{ fontStyle: 'italic', fontSize: '13px' }}>
									<Spinner animation="border" className="me-1" /> Enregistrement...
								</span>
							) : (
								<span className='text-success' style={{ fontWeight: '500', fontSize: '13px' }}>
									<Icon icon='CheckCircleOutline' color='success' size={"2x"} /> Enregistré
								</span>
							)}
						</div>
					}
				</div>
			</Modal.Header>
			<Modal.Body className='p-0'>
				<div>
					<h1 style={{ color: COLORS.DEFAULT }} className='mt-5 text-center'>
						{data?.reference} - {statut[data?.statut]}
					</h1>

					<div className='p-3'>
						{/* ===== INPUT ===== */}
						<div>
							<div
								style={{ color: COLORS.DEFAULT }}
								className='mb-2 ms-4 fw-semibold'>
								Titre de devis
							</div>
							<Input
								type='text'
								value={data?.name}
								onChange={(e) =>
									!isAccepted && setData({ ...data, name: e.target.value })
								}
								className='rounded-5'
								style={{ height: '50px' }}
								readOnly={isAccepted}
							/>
						</div>

						{/* ===== ACTION BUTTONS ===== */}
						{!isAccepted && (
							<>
								{/* ===== ACTION BUTTONS ===== */}
								<div className='actions mt-4'>
									<button
										className='action-btn'
										onClick={() => {


											setEditModalSimulator(true);
										}}>
										<img src={SimulatorIcon} alt='Simulateur' />
										<span>Fourniture</span>
									</button>
									<button
										className='action-btn'
										onClick={() => setEditModalForfait('forfaits')}>
										<img src={Forfait} alt='Produit' />
										<span>Forfaits</span>
									</button>
									<button
										className='action-btn'
										onClick={() => setEditModalForfait('main')}>
										<img src={MainDoeuvre} alt='Produit' />
										<span>Main d'oeuvre</span>
									</button>
								</div>
								<div className='gap-4 d-flex mt-4'>
									<button
										className='action-btn justify-content-center w-50'
										onClick={addDeplacement}
										disabled={spinnerDepacement}>
										<img src={Truck} alt='Déplacement' />
										<span>Déplacement</span>
									</button>
									<button
										className='action-btn justify-content-center w-50'
										onClick={addGarantie}
										disabled={spinnerDepacement}>
										<img src={Garantie} alt='Déplacement' />
										<span>Garantie</span>
									</button>
								</div>
							</>
						)}

						{/* ===== TABLE ===== */}
						<DevisTable
							cardId={data?._id}
							card={data?.lignes}
							isDisabled={isAccepted}
							updateLineDevis={(line) => {
								!isAccepted && setSelectedLineDevis(line);
								!isAccepted && setLineDevisPopup(true);
							}}
							data={data}
							setData={setData}
							taxes={taxes}
						/>
					</div>

					{/* ===== NOTES ===== */}
					<div className='form-group m-4'>
						<div className='textarea-wrapper'>
							<label className='textarea-label'>Notes de devis</label>
							<textarea
								className='textarea-input'
								value={data?.notesClient || ''}
								onChange={(e) =>
									!isAccepted && setData({ ...data, notesClient: e.target.value })
								}
								rows={4}
								readOnly={isAccepted}
							/>
						</div>
					</div>
					{!!data?.signature && (
						<div className='form-group mb-5'>
							<div className='textarea-wrapper'>
								<label className='textarea-label'>Signature</label>
								<div className='space-y-2 small mx-3'>
									<img
										src={`/coreService/${data?.signature}`}
										alt='Company Logo'
										height={'100'}
										style={{
											objectFit: 'contain',
										}}
										className='w-100 mb-4 border p-2 rounded'
									/>

									<div className='d-flex justify-content-between'>
										<span className='text-muted'>Signé le:</span>
										<span>
											{' '}
											{moment(data?.signedOn).format('DD/MM/yyyy HH:mm')}
										</span>
									</div>
								</div>
							</div>
						</div>
					)}
					{/* ===== FOOTER ===== */}
					{!isAccepted && (
						<div className='footer-actions  mx-4 mb-4 d-flex flex-column'>
							{/* <Button
								isLight
								className='col-12'
								color='primary'
								onClick={handleUpdateDevis}
								disabled={spinner}>
								{spinner ? 'Loading...' : 'Enregistrer'}
							</Button> */}
							<Button
								style={{
									borderRadius: 8,
									backgroundColor: COLORS.PRIMARY,
									color: COLORS.WHITE,
									border: "none"
								}}
								className='col-12'
								onClick={async () => {
									// const resUpdate = await updateDevis(data?._id, data);
									// UpdateDevis(resUpdate?.data);
									setOpenEmail(true);
								}}
								disabled={spinner}>
								{spinner ? 'Loading...' : 'Envoyer'}
							</Button>
							<Button
								style={{
									borderRadius: 8,
									backgroundColor: COLORS.PRIMARY,
									color: COLORS.WHITE,
									border: "none"
								}}
								className='col-12'
								onClick={async () => {
									// const resUpdate = await updateDevis(data?._id, data);
									// UpdateDevis(resUpdate?.data);
									setOpenSignature(true);
								}}
								disabled={spinner}>
								{spinner ? 'Loading...' : 'Accepter'}
							</Button>
							<Button
								className='col-12'
								style={{
									borderRadius: 8,
									backgroundColor: COLORS.PRIMARY,
									color: COLORS.WHITE,
									border: "none"
								}}
								tag='a'
								disabled={spinner}
								href={`/coreService/document-layouts/download/Devis/${data?._id}`}
								target='_blank'>
								{spinner ? 'Loading...' : 'Télécharger'}
							</Button>

							<Button
								className='col-12'
								onClick={() => setShowDeleteConfirm(true)}
								disabled={deleteLoading}
								color='danger'
							>
								{deleteLoading ? 'Loading...' : 'Supprimer'}
							</Button>
						</div>
					)}
					{isAccepted && (
						<div className='footer-actions mx-4 mb-4 d-flex flex-column'>
							<Button

								className='col-12'
								style={{
									borderRadius: 8,
									backgroundColor: COLORS.PRIMARY,
									color: COLORS.WHITE
								}}
								color='primary'
								onClick={() => setOpenEmail(true)}
								disabled={spinner}>
								{spinner ? 'Loading...' : 'Envoyer'}
							</Button>

							<Button
								className='col-12'
								isLight
								tag='a'
								color='primary'
								disabled={spinner}
								href={`/coreService/document-layouts/download/Devis/${data?._id}`}
								target='_blank'>
								{spinner ? 'Loading...' : 'Télécharger'}
							</Button>
							<Button
								className='col-12'

								color='primary'
								disabled={loadingDuplique}
								onClick={handleDupliquer}
							>
								{loadingDuplique ? 'Loading...' : 'Dupliquer'}
							</Button>
						</div>
					)}

					{lineDevisPopup && (
						<UpdateDevisLineModal
							index={selectedLineDevis?.index}
							ligne={selectedLineDevis}
							setVisible={() => setLineDevisPopup(false)}
							setData={setData}
						/>
					)}
				</div>
				{!!openSignature && (
					<SignaturePopup
						setOpenSignature={setOpenSignature}
						devis={data}
						loadDevisData={handleAcceptDevis}
					/>
				)}
				{openEmail && (
					<EmailSendPopup
						isOpen={openEmail}
						setIsOpen={setOpenEmail}
						model='Devis'
						recordId={data?._id}
						fnSuccess={handleSendEmail}
						EmailType={data.statut == 'accepté' ? 'accepté' : 'Default'}
					/>
				)}
				{!!editModalSimulator && (
					<SimulatorPopUp
						setEditModalSimulator={setEditModalSimulator}
						data={{
							order_id: 1,
							modalTitle: 'Conception de produits et simulation',
							cardTitle: 'Simulate Product',
						}}
						simulatorData={simulatorData}
						currentFormValue={currentFormValue}
						setCurrentFormValue={setCurrentFormValue}
						handelCreateLine={handelAddFournitureLine}>
						<Row className='px-3'>
							<Col>
								{/* {currentFormValue?.complet && ( */}
								<Button
									variant='outline-info'
									onClick={() => {
										console.log('finaaaaal', currentFormValue?.productFinal);
										handelAddFournitureLine();
									}}
									disabled={!currentFormValue?.complet || addSimulatorLoading}
									style={{
										borderRadius: '10px',
										width: '100%',
										backgroundColor: 'rgba(23, 162, 184, 0.1)',
										border: '1px solid #17a2b8',
									}}>
									{!!currentFormValue?.complet ? addSimulatorLoading ? (
										<>
											<span className='spinner-border spinner-border-sm me-2' />
											Loading...
										</>
									) : (
										<span style={{ color: '#17a2b8', fontWeight: '600' }}>
											Ajouter au devis
										</span>
									) : "⚠️ Simulation incomplète"}
								</Button>
								{/* )} */}
							</Col>
						</Row>
					</SimulatorPopUp>
				)}
				{!!editModalForfait && (
					<SimulatorPopUpFacile
						setEditModalSimulator={setEditModalForfait}
						data={{
							order_id: 1,
							modalTitle: `${modalTitle[interventionData?.motif]}`,
							cardTitle: 'Simulate Product',
						}}
						simulatorData={editModalForfait == 'forfaits' ? ForfaitsSM : MainOuvreData}

						currentFormValue={currentFormValue}
						setCurrentFormValue={setCurrentFormValue}>
						<Row className='px-2 px-md-3'>
							<Button
								color='primary'
								onClick={() => {
									editModalForfait == 'forfaits'
										? handelCreateForfaitLine()
										: handelCreateMainDoeuvreLine();
								}}
								disabled={
									!(
										currentFormValue &&
										typeof currentFormValue === 'object' &&
										Object.values(currentFormValue).some(
											(v) =>
												v !== null &&
												v !== undefined &&
												String(v).trim() !== '',
										)
									) || addSimulatorLoading
								}
								style={{
									borderRadius: '10px',
									width: '100%',
								}}>
								{addSimulatorLoading ? (
									<>
										<span className='spinner-border spinner-border-sm me-2' />
										Loading...
									</>
								) : (
									'Sauvegarder'
								)}
							</Button>
						</Row>
					</SimulatorPopUpFacile>
				)}
				{showDeleteConfirm && (
					<ConfirmationPopup
						setOpen={setShowDeleteConfirm}
						title={'Êtes-vous sûr de vouloir supprimer le devis ? '}
						label={"Cette action est irréversible. Le devis sera définitivement supprimé."}
						isLoading={deleteLoading}
						handleConfirm={handleDelete}
					/>
				)}
			</Modal.Body>
		</Modal>
	);
}

export default UpdateDevisModal;
